import { AppIconAmountEqual } from './components/amount-equal-icon'
import { AppIconAmountSwap } from './components/amount-swap-icon'
import { AppIconArrowTopRightBold } from './components/arrow-top-right-bold-icon'
import { AppIconBackspace } from './components/backspace-icon'
import { AppIconBank } from './components/bank-icon'
import { AppIconCalendarCheck } from './components/calendar-check-icon'
import { AppIconChats } from './components/chats-icon'
import { AppIconChatsOutline } from './components/chats-outline-icon'
import { AppIconCloseCircle } from './components/close-circle-icon'
import { AppIconCurrencyAll } from './components/currency-all-icon'
import { AppIconDeleteAccount } from './components/delete-account-icon'
import { AppIconEyeOutline } from './components/eye-outline-icon'
import { AppIconHistory } from './components/history-icon'
import { AppIconHistorySolid } from './components/history-solid-icon'
import { AppIconHome } from './components/home-icon'
import { AppIconHomeOutline } from './components/home-outline-icon'
import { AppIconInfoCircle } from './components/info-circle-icon'
import { AppIconInfoOutline } from './components/info-outline-icon'
import { AppIconKycVerifyOutline } from './components/kyc-verify-outline-icon'
import { AppIconMiniAppPurchase } from './components/mini-app-purchase-icon'
import { AppIconMiniAppTopup } from './components/mini-app-topup-icon'
import { AppIconPlusBold } from './components/plus-bold-icon'
import { AppIconProfileCircleOutline } from './components/profile-circle-outline-icon'
import { AppIconProfileRounded } from './components/profile-rounded-icon'
import { AppIconProfileRoundedOutline } from './components/profile-rounded-outline-icon'
import { AppIconRedo } from './components/redo-icon'
import { AppIconRefresh } from './components/refresh-icon'
import { AppIconScanBold } from './components/scan-bold-icon'
import { AppIconServices } from './components/services-icon'
import { AppIconServicesOutline } from './components/services-outline-icon'
import { AppIconSwapArrows } from './components/swap-arrows-icon'
import { AppIconSwapBold } from './components/swap-bold-icon'
import { AppIconSwipeArrowRight } from './components/swipe-arrow-right-icon'
import { AppIconTether } from './components/tether-icon'
import { AppIconUnfreeze } from './components/unfreeze-icon'
import { AppIconWallet } from './components/wallet-icon'
import { AppIconWalletOutline } from './components/wallet-outline-icon'
import { kitIcons } from './ui-kit'

// Локальные SVG перекрывают icomoon без пересборки шрифта (AppIcon смотрит сюда первым).
export const localIcons = {
  'amount-swap': AppIconAmountSwap,
  'amount-equal': AppIconAmountEqual,
  ...kitIcons,
  unfreeze: AppIconUnfreeze,
  bank: AppIconBank,
  // брендовый цвет / knockout — в моно-шрифте деградируют, остаются SVG
  tether: AppIconTether,
  'eye-outline': AppIconEyeOutline,
  'close-circle': AppIconCloseCircle,
  'delete-account': AppIconDeleteAccount,
  'info-circle': AppIconInfoCircle,
  'calendar-check': AppIconCalendarCheck,
  'kyc-verify-outline': AppIconKycVerifyOutline,
  'profile-circle-outline': AppIconProfileCircleOutline,
  // синий глобус в строке выбора валюты на экране лимитов
  'currency-all': AppIconCurrencyAll,
  // градиентная заливка (fill=url) — моно-глиф шрифта не сохранит градиент, остаются SVG
  'plus-bold': AppIconPlusBold,
  'swap-bold': AppIconSwapBold,
  'scan-bold': AppIconScanBold,
  'arrow-top-right-bold': AppIconArrowTopRightBold,
  // многоцветный логотип платёжной системы
  // возврат средств в статусе отменённого пополнения
  redo: AppIconRedo,
  // иконки экрана пополнения — векторы из макета, глифы шрифта отличаются от дизайна.
  // Отдельное имя: глиф `refresh` (две стрелки) остаётся у остальных экранов
  'refresh-arrow': AppIconRefresh,
  'swap-arrows': AppIconSwapArrows,
  'info-outline': AppIconInfoOutline,
  backspace: AppIconBackspace,
  // двухтоновые серые — в моно-шрифте теряют оттенок, остаются SVG
  'mini-app-purchase': AppIconMiniAppPurchase,
  'mini-app-topup': AppIconMiniAppTopup,
  // двойной шеврон с полупрозрачным дублем — в моно-шрифте прозрачность не выразить
  'swipe-arrow-right': AppIconSwipeArrowRight,
  // двухтоновые цветные nav-иконки (серый + синий акцент) — в моно-шрифт не ложатся
  history: AppIconHistory,
  'history-solid': AppIconHistorySolid,
  home: AppIconHome,
  'home-outline': AppIconHomeOutline,
  chats: AppIconChats,
  'chats-outline': AppIconChatsOutline,
  services: AppIconServices,
  'services-outline': AppIconServicesOutline,
  wallet: AppIconWallet,
  'wallet-outline': AppIconWalletOutline,
  profile: AppIconProfileRounded,
  'profile-outline': AppIconProfileRoundedOutline,
  'profile-rounded': AppIconProfileRounded,
  'profile-rounded-outline': AppIconProfileRoundedOutline,
}
